module.exports = __webpack_public_path__ + "img/19050522_2294415584116947_8044520126759829504_a.253dd5b8.jpg";